import { default as Toast } from "vue-toastification/dist/index.mjs"; // Explicitly import ESM version

// Using require instead of import for CSS
require("vue-toastification/dist/index.css");

export const addPlugins = (app) => {
  app.use(Toast);
};
